export function incrementTour(state) {
  return {
    ...state,
    stepIndex: incrementStepIndex(state.stepIndex),
  };
}

function incrementStepIndex(stepIndex) {
  return stepIndex + 1;
}
